import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { useActiveTemplateId } from './use-active-project-template';

const getAllProjectPhasesSelector = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): number[] =>
      project.data[templateId]?.template.templateContent?.projectPhases ?? [],
  );

export const useGetAllProjectPhasesInTemplate = (): number[] => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getAllProjectPhasesSelector, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
